import { useRecoilValue } from 'recoil'
import { useRouter } from 'next/router'
import { loadStripe } from '@stripe/stripe-js'
import { userInfoState } from '@/util/states'

const stripePromise = loadStripe(process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY)

export const useCheckout = () => {
  const userInfo = useRecoilValue(userInfoState)
  const router = useRouter()

  const handleCheckout = async ({ id, title, url, price, endpoint = 'singleCheckout' }) => {
    if (userInfo === 'pending') return

    if (!userInfo) {
      router.push({
        pathname: '/signup',
        query: { returnUrl: router.asPath }
      })
      return
    }

    try {
      const res = await fetch(`/api/${endpoint}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          pathname: router.pathname,
          postId: id,
          postUrl: url,
          title,
          userId: userInfo.uid,
          price
        })
      })

      const { sessionId } = await res.json()

      const stripe = await stripePromise
      if (stripe) {
        const { error } = await stripe.redirectToCheckout({ sessionId })
        if (error) {
          console.error('Stripe redirect error:', error)
        }
      } else {
        console.error('Stripe object was null')
      }
    } catch (err) {
      console.error('Checkout failed:', err)
    }
  }

  return { handleCheckout }
}
